import styled from 'styled-components';

import { EllipsisTextStyle } from '@/components/atom/text/DefaultText';
import theme from '@/styles/theme';
import { Magazine, RandomMagazine } from '@/types/magazine';
import { absoluteTime } from '@/utils/format';

interface MagazineItemProps {
  magazine: Magazine | RandomMagazine;
  pageName: string;
  containerStyle?: React.CSSProperties;
  onClickMagazine: () => Promise<void>;
}

const SearchMagazineItem = ({ magazine, containerStyle, onClickMagazine }: MagazineItemProps) => {
  return (
    <Wrapper onClick={onClickMagazine} style={containerStyle}>
      <Left>
        <Category>
          <span>{magazine.createdDate}</span>
          <time dateTime={absoluteTime(magazine.createdAt)} />
        </Category>
        <Title>{magazine.mobileTitle}</Title>
        <Description>{magazine.mobileDescription}</Description>
      </Left>
      <Right>
        <ImageWrapper>
          <Img src={magazine.titleImageUrl} />
        </ImageWrapper>
        {magazine.author && <DoctorColumn>의사 칼럼</DoctorColumn>}
      </Right>
    </Wrapper>
  );
};

export default SearchMagazineItem;

const Wrapper = styled.article`
  padding: 24px;
  display: flex;

  &:active {
    background: ${({ theme }) => theme.color.gray30};
  }
`;

const Left = styled.div`
  margin-right: 20px;
  width: calc(100% - 116px);
`;

const Category = styled.div`
  margin-bottom: 8px;
  * {
    &:nth-child(1) {
      ${theme.typography.UI12M};
      color: ${theme.color.primary500};
    }
    &:nth-child(3) {
      ${theme.typography.UI12M};
      color: ${theme.color.gray400};
    }
  }

  svg {
    margin: 0 8px;
  }

  time {
    visibility: hidden;
  }
`;

const Title = styled.h2`
  ${EllipsisTextStyle};
  ${theme.typography.UI16SB};
  color: ${theme.color.gray700};
  margin-bottom: 4px;
`;

const Description = styled.p`
  ${EllipsisTextStyle};
  ${theme.typography.UI14R};
  color: ${theme.color.gray500};
`;

const ImageWrapper = styled.div`
  width: 100%;
  position: relative;
  border: 1px solid ${theme.color.gray200};
  border-radius: 8px;
  overflow: hidden;
  margin-top: 4px;
`;

const Img = styled.img`
  width: 94px;
  height: 70px;
  object-fit: cover;
`;

const DoctorColumn = styled.div`
  ${theme.typography.UI12M};
  color: ${theme.color.blue500};
  background: ${theme.color.blue100};
  padding: 5px 0;
  text-align: center;
  border-radius: 4px;
  margin-top: 4px;
`;

const Right = styled.div``;
